import RoutePlanningProvider from 'providers/RoutePlanningProvider'
import LayoutWithSecondarySidebar from 'components/Layout/LayoutWithSecondarySidebar'
import { Box } from '@mui/material'
import { useEffect, useState } from 'react'
import { useIsFetching } from 'react-query'
import { format } from 'date-fns'
import { useParams } from 'react-router-dom'
import { usePlace } from 'hooks/usePlaces'
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator'
import { usePlaces } from 'providers/PlacesProvider'
import Map from './Map'
import Sidebar from './Sidebar'
import OrderListing from './OrderListing'

const RoutePlanning = () => {
  const { placeId } = useParams()
  const { isLoading, place } = usePlace(placeId as string)
  const [date, setDate] = useState(new Date())
  const isFetching = useIsFetching(['ordersForPlace'])
  const isFetchingDeliveries = useIsFetching(['deliveries'])
  const { setSelectedPlace } = usePlaces()

  useEffect(() => {
    if (!isLoading) {
      setSelectedPlace(place)
    }
  }, [isLoading])

  const formattedDate = format(date, 'yyyy-MM-dd')
  if (!isLoading) {
    return (
      <RoutePlanningProvider
        placeId={placeId as string}
        startDate={formattedDate}
        endDate={date}>
        <LayoutWithSecondarySidebar sidebar={<Sidebar />} sx={{ pr: 0 }}>
          {isFetching === 1 || isFetchingDeliveries === 1 ? (
            <LoadingIndicator />
          ) : (
            <Box display='flex' ml={-2} mt={-2}>
              <Box width='calc(100% - 410px)'>
                <Map
                  latitude={place.latitude}
                  longitude={place.longitude}
                  date={date}
                  setDate={setDate}
                />
              </Box>
              <OrderListing />
            </Box>
          )}
        </LayoutWithSecondarySidebar>
      </RoutePlanningProvider>
    )
  }
  return null
}

export default RoutePlanning
